const TerminalRoute = () => {
  return (
    <span className="terminal-line-route terminal-line">me@/portfolio:~$ </span>
  );
};

export default TerminalRoute;
